import { ActivityContext } from "../../types"

export const getDefaultAsset = (ctx: ActivityContext) => {
  return (
    ctx.availableAssets?.[0]?.id ?? ctx.asset?.id ?? ctx.activity.assets?.[0]?.id ?? ctx.order?.assets?.[0]?.id ?? null
  )
}

export const getAsset = (ctx: ActivityContext) => {
  console.log("[getAsset] ctx", ctx)
  if (ctx.asset) {
    return ctx.asset
  }
  if (ctx.selectedAsset && ctx.order?.assets) {
    const asset = ctx.order?.assets.find((a) => a.id === ctx.selectedAsset)
    if (asset) {
      return asset
    }
  }
  if (ctx.selectedAsset && ctx.activity.assets) {
    const asset = ctx.activity.assets.find((a) => a.id === ctx.selectedAsset)
    if (asset) {
      return asset
    }
  }
  return ctx.order?.assets?.[0] ?? undefined
}
